import ScrollLock from '../libs/scroll-lock.js';
import Slides from '../libs/slides.js';

export default function LandingPage() {
    let elements = document.querySelectorAll('.view');
    let sliders = document.querySelectorAll('.landingpage__slide');

    let slider = window.slides = new Slides(sliders);
    let lock = window.lock = new ScrollLock(elements, slider);

    return {slides, lock};
};
